// This module exists in order to share directives and pipes between app and app-classic modules
// Angular does not allow directives or pipes to be declared in more than one module in a project, so
// as long as app-classic exists, we need this module to share directives/pipes
// once app-classic is removed, this module will also be deleted which will cause an error in app.module
// file (but there should be instructions there on what to do as well)
import { NgModule } from '@angular/core';
import { HorizontalScrollDirective } from '../app/directives/horizontal-scroll.directive';
import { SafePipe } from '../app/pipes/safe.pipe';

@NgModule({
    declarations: [HorizontalScrollDirective, SafePipe],
    exports: [HorizontalScrollDirective, SafePipe],
})
export class SharedDirectivesAndPipesModule {}
